import empty from '@/views/default/empty'
import AveragePurchasePrice from "@/views/quotation/AveragePurchasePrice"
import SupplierMaintain from "@/views/quotation/SupplierMaintain"
import SupplierOthersMaintain from "@/views/quotation/SupplierOthersMaintain"
import SupplierMetalMaintain from "@/views/quotation/SupplierMetalMaintain"
import SupplierPlasticMaintain from "@/views/quotation/SupplierPlasticMaintain"
import SupplierPwbMaintain  from "@/views/quotation/SupplierPwbMaintain"
import SupplierToolingDetailMaintain from "@/views/quotation/SupplierToolingDetailMaintain"
import SupplierRfqDetailMaintain from "@/views/quotation/SupplierRfqDetailMaintain"
import CpcMaintain from "@/views/quotation/CpcMaintain"
import CpcDetailMaintain from "@/views/quotation/CpcDetailMaintain"
import CpcRfqDetailMaintain from "@/views/quotation/CpcRfqDetailMaintain"
import CpcToolingDetailMaintain from "@/views/quotation/CpcToolingDetailMaintain"
import SupervisorMaintain from "@/views/quotation/SupervisorMaintain"
import SupervisorToolingGroupMaintain from "@/views/quotation/SupervisorToolingGroupMaintain"
import SupervisorRfqGroupMaintain from "@/views/quotation/SupervisorRfqGroupMaintain"
import SupervisorGroupMaintain from "@/views/quotation/SupervisorGroupMaintain"
import HistoryReport from "@/views/quotation/HistoryReport"
import StatusReport from "@/views/quotation/StatusReport"
import StatusReportCpcDetail from "@/views/quotation/StatusReportCpcDetail"
import StatusReportHighPriceDetail from "@/views/quotation/StatusReportHighPriceDetail"
import RmTpyeMaintain from "@/views/quotation/RmTpyeMaintain"
import RmVendorMaintain from "@/views/quotation/RmVendorMaintain"
import RmPartNoMaintain from "@/views/quotation/RmPartNoMaintain"
import RmDistributorMaintain from "@/views/quotation/RmDistributorMaintain"
import SteelReferencePriceMaintain from "@/views/quotation/SteelReferencePriceMaintain"
import ResinReferencePriceMaintain from "@/views/quotation/ResinReferencePriceMaintain"
import CclMasterMaintain from "@/views/quotation/CclMasterMaintain"
import PcbMasterMaintain from "@/views/quotation/PcbMasterMaintain"
import PcbGroup from "@/views/quotation/PcbGroup"
import HistoryRfqReport from '@/views/quotation/HistoryRfqReport'
import RfqStatusReport from '@/views/quotation/RfqStatusReport'

import CpcHighPriceMaintain from "@/views/quotation/CpcHighPriceMaintain"
import SupervisorHighPriceMaintain from "@/views/quotation/SupervisorHighPriceMaintain"

export default [
    {
        path: '/quotation',
        name: 'QUOTATION',
        component: empty,
        children: [
            {
                path: 'average-purchase-price',
                name: 'AVERAGE_PURCHASE_PRICE_MAINTAIN',
                component: AveragePurchasePrice,
            },
            {
                path: 'supplier-maintain',
                component: empty,
                children: [
                    {
                        path: 'search',
                        name: 'SUPPLIER_MAINTAIN',
                        component: SupplierMaintain,
                    },
                    {
                        path: 'detail',
                        name: 'SUPPLIER_OTHERS_MAINTAIN',
                        component: SupplierOthersMaintain
                    },
                    {
                        path: 'steel-detail',
                        name: 'SUPPLIER_METAL_MAINTAIN',
                        component: SupplierMetalMaintain
                    },
                    {
                        path: 'resin-detail',
                        name: 'SUPPLIER_PLASTIC_MAINTAIN',
                        component: SupplierPlasticMaintain
                    },
                    {
                        path: 'pwb-detail',
                        name: 'SUPPLIER_PWB_MAINTAIN',
                        component: SupplierPwbMaintain
                    },
                    {
                        
                        path: 'tooling-detail',
                        name: 'TOOLING_SUPPLIER_DETAIL_MAINTAIN',
                        component: SupplierToolingDetailMaintain
                    },
                    {
                        
                        path: 'rfq-detail',
                        name: 'RFQ_SUPPLIER_DETAIL_MAINTAIN',
                        component: SupplierRfqDetailMaintain,
                        props: true
                    },
                ],
            },
            {
                path: 'history',
                component: empty,
                children: [
                    {
                        path: 'search',
                        name: 'QUOTATION_HISTORY_REPORT',
                        component: HistoryReport,
                    },
                    {
                        
                        path: 'rfq-detail',
                        name: 'RFQ_QUOTATION_HISTORY_REPORT',
                        component: HistoryRfqReport
                    }
                ],
            },
            {
                path: 'report',
                component: empty,
                children: [
                    {
                        path: 'search',
                        name: 'STATUS_REPORT',
                        component: StatusReport,
                    },
                    {
                        path: 'search',
                        name: 'RFQ_STATUS_REPORT',
                        component: RfqStatusReport,
                    },
                    {
                        path: 'detail',
                        name: 'STATUS_REPORT_CPC_DETAIL',
                        component: StatusReportCpcDetail,
                        props: true
                    },
                    {
                        path: 'detail',
                        name: 'STATUS_REPORT_HIGH_PRICE_DETAIL',
                        component: StatusReportHighPriceDetail,
                        props: true
                    }
                ],
            },
            {
                path: 'cpc-maintain',
                component: empty,
                children: [
                    {
                        path: 'search',
                        name: 'CPC_MAINTAIN',
                        component: CpcMaintain,
                    },
                    {
                        path: 'detail/formNo',
                        name: 'CPC_MAINTAIN_DETAIL_FORM_NO',
                        component: CpcDetailMaintain
                    },
                    {
                        path: 'tooling-detail/formNo',
                        name: 'CPC_MAINTAIN_DETAIL_TOOLING_FORM_NO',
                        component: CpcToolingDetailMaintain
                    },
                    {
                        path: 'detail/partNo',
                        name: 'CPC_MAINTAIN_DETAIL_PART_NO',
                        component: CpcDetailMaintain
                    },
                    {
                        path: 'tooling-detail/toolingId',
                        name: 'CPC_MAINTAIN_DETAIL_TOOLING_ID',
                        component: CpcToolingDetailMaintain
                    },
                    {
                        path: 'detail/vendorName',
                        name: 'CPC_MAINTAIN_DETAIL_VENDOR_NAME',
                        component: CpcDetailMaintain
                    },
                    {
                        path: 'tooling-detail/vendorName',
                        name: 'CPC_MAINTAIN_DETAIL_TOOLING_VENDOR_NAME',
                        component: CpcToolingDetailMaintain
                    },
                    {
                        path: 'detail/groupId',
                        name: 'CPC_MAINTAIN_DETAIL_GROUP_ID',
                        component: CpcDetailMaintain
                    },
                    {
                        path: 'tooling-detail/groupId',
                        name: 'CPC_MAINTAIN_DETAIL_TOOLING_GROUP_ID',
                        component: CpcToolingDetailMaintain
                    },
                    {
                        path: 'rfq-detail/groupId',
                        name: 'CPC_MAINTAIN_DETAIL_RFQ_GROUP_ID',
                        component: CpcRfqDetailMaintain,
                        props: true
                    }
                ],
            },
            {
                path: 'cpc-high-price-maintain',
                component: empty,
                children: [
                    {
                        path: 'search',
                        name: 'CPC_HIGH_PRICE_MAINTAIN',
                        component: CpcHighPriceMaintain,
                    }
                ],
            },
            {
                path: 'supervisor-maintain',
                component: empty,
                children: [
                    {
                        path: 'search',
                        name: 'SUPERVISOR_MAINTAIN',
                        component: SupervisorMaintain,
                    },
                    {
                        path: 'detail/groupId',
                        name: 'SUPERVISOR_MAINTAIN_DETAIL_GROUP_ID',
                        component: SupervisorGroupMaintain,
                        props: true
                    },
                    {
                        path: 'detail-tooling/groupId',
                        name: 'SUPERVISOR_MAINTAIN_DETAIL_TOOLING_GROUP_ID',
                        component: SupervisorToolingGroupMaintain,
                        props: true
                    },
                    {
                        path: 'detail-rfq/groupId',
                        name: 'SUPERVISOR_MAINTAIN_DETAIL_RFQ_GROUP_ID',
                        component: SupervisorRfqGroupMaintain,
                        props: true
                    },
                ],
            },
            {
                path: 'supervisor-high-price-maintain',
                name: 'SUPERVISOR_HIPH_PRICE_MAINTAIN',
                component: SupervisorHighPriceMaintain,
            },
            {
                path: 'rm-type-maintain',
                name: 'RM_TYPE_MAINTAIN',
                component: RmTpyeMaintain,
            },
            {
                path: 'rm-vendor-maintain',
                name: 'RM_VENDOR_MAINTAIN',
                component: RmVendorMaintain,
            },
            {
                path: 'rm-distributor-maintain',
                name: 'RM_DISTRIBUTOR_MAINTAIN',
                component: RmDistributorMaintain,
            },
            {
                path: 'rm-part-no-maintain',
                name: 'RM_PART_NO_MAINTAIN',
                component: RmPartNoMaintain,
            },
            {
                path: 'steel-reference-price-maintain',
                name: 'STEEL_REFERENCE_PRICE_MAINTAIN',
                component: SteelReferencePriceMaintain,
            },
            {
                path: 'resin-reference-price-maintain',
                name: 'RESIN_REFERENCE_PRICE_MAINTAIN',
                component: ResinReferencePriceMaintain,
            },
            {
                path: 'ccl-master-maintain',
                name: 'CCL_MASTER_MAINTAIN',
                component: CclMasterMaintain,
            },
            {
                path: 'pcb-master-maintain',
                name: 'PCB_MASTER_MAINTAIN',
                component: PcbMasterMaintain,
            },
            {
                path: 'pcb-group-maintain',
                name: 'PCB_GROUP_MAINTAIN',
                component: PcbGroup,
            },
        ]
    }
]
